import React from 'react';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';

import { teams } from '../CreateCardForm/teamslist';
function FilterComponent({ filterValues, removeFilter, clearCategory,handleClearFilters,sport }) {
      // Helper function to map 0 and 1 to 'False' and 'True' respectively
      const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  // const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure
 console.log("Current sport:", sport); // Debugging line to check the current language
      // Safe translation function
      const t = (key) => {
        if (!translations.CardGrid || !translations.CardGrid[key]) {
          console.warn(`Missing translation key: ${key}`); // Log missing keys
          return key; // Return the key as fallback instead of breaking the app
        }
      
        return translations.CardGrid[key][currentLang] || key;
      };

  function FindTheTeamNameById(teamId) {
    const team = teams[teamId];
    return team ? team.name : "Unknown Team";
  }

      const modifyLabel = (label) => {
        if (label === "NotisPC") { return t("NotPC"); }
        else if (label === "isPC") { return t("PC"); }
        else if (label === "NotisOnEbay") { return t("NotOnEbay"); }
        else if (label === "isOnEbay") { return t("OnEbay"); }
        else if (label === "NotisForTrade") { return t("NotForTrade"); }
        else if (label === "isForTrade") { return t("ForTrade"); }
        else if (label === "NotisForSale") { return t("NotForSale"); }
        else if (label === "isForSale") { return t("ForSale"); }
        else if (label === "Name") { return sport==='Hockey' ? t("Player") : "Pokemon"; }
        else if (label === "TeamsId") { return t("Team(Uniform)"); }
        else if (label === "SetName") { return t("Set"); }
        else if (label === "cardName") { return t("cardName"); }
        else if (label === "variationName") { return t("variation"); }
        else if (label === "YearMade") { return t("year"); }
        else if (label === "IsAuto") { return t("auto"); }
        else if (label === "IsRookie") { return t("rookie"); }
        else if (label === "IsPatch") { return t("patch"); }
        else if (label === "IsJersey") { return t("jersey"); }
        else if (label === "IsAuto") { return t("auto"); }
        else if (label === "GradeCompany") { return t("GradingCompany"); }
        else if (label === "ShowName") { return t("ShowName"); }
        else if (label === "Yes") { return t("Yes"); }
        else if (label === "No") { return t("No"); }
        else if (label === "isGone") { return t("RecentlyDeleted"); }
        else if (label === "Graded") { return t("Graded"); }
        else if (label === "SavedSeller") { return t("SavedSeller"); }
        else {
          return label;
        }
      };
     
      const mapToVisualValue = (category, value) => {

        
        if (category === 'Grade' || category === 'minPrice'|| category === 'maxPrice') {
          // For specific categories, display the integer value
          return value;
        } else if(value==='1'|| value==='0'){
          // For all other categories, display "Yes" for true and "No" for false
          return value === '1' ? 'Yes' : 'No';
        }
        else if(value===category|| value===(`Not${category}`)){
          // For all other categories, display "Yes" for true and "No" for false
          return value === category ? 'Yes' : 'No';
        }
        else if (category ==='TeamsId' && value!=='TeamsId')
          return FindTheTeamNameById(value)
        else 
        return value
      };
      

  return (
    <div className='filters'>

      {Object.entries(filterValues).filter(([category]) => !['minPrice', 'maxPrice'].includes(category))
      .map(([category, filterObj]) => (
        <div key={category} className='listatpris'>
          {/* <button onClick={() => clearCategory(category)}>X</button> */}

          <h4>
            {category === 'Name' ? (sport==='Hockey' ? t("Player") : "Pokemon") : category === 'isGone' ? t('isGone') : category === 'cardName' ? t('cardName') : category === 'variationName' ? t('Variation') : category === 'SetName' ? t('Set') : category === 'YearMade' ? t('year') : category === 'IsPatch' ? t('patch') : category === 'isJersey' ? t('jersey') : category === 'isAuto' ? t('auto') : category === 'isPC' ? t('PC') : category === 'isForSale' ? t('ForSale') : category === 'isForTrade' ? t('ForTrade') : category === 'isOnEbay' ? t('OnEbay') : category === 'ShowName' ? t('ShowName') : category === 'TeamsId' ? t('Team(Uniform)') : category}
          </h4>:
          {Object.keys(filterObj)
            .filter((filter) => filterObj[filter]) // Filter out false values
            .map((filter) => (
                <button key={filter} className='btn-simple' onClick={() => removeFilter(category, filter)}><p> {modifyLabel(mapToVisualValue(category,filter))}</p> <p>X</p></button>
               
              
            ))}
        </div>
      ))}
    </div>
  );
}

export default FilterComponent;
